import { InputBase, Paper } from "@mui/material";
import React from "react";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
const CustomSearchTrackinPaper = ({
  searchQuery,
  setSearchQuery,
  showSearchdata,
  responseData,
  placeholder,
  handleAddData
}) => {
  return (
    <Paper
      className="track-full-searchbar-modal"
      // component="form"
      sx={{
        p: "2px 4px",
        display: "flex",
        alignItems: "center",
        width: "300",
      }}
    >
      <SearchIcon className="searchicon-in-header" />
      <InputBase
        value={searchQuery}
        onChange={(e) => {
          const inputValue = e.target.value;
          setSearchQuery(inputValue);
        }}
        className="search-inner-text"
        sx={{ ml: 1, flex: 1 }}
        placeholder={placeholder}
        inputProps={{ "aria-label": "Search" }}
        autoComplete="off"
      />
      <div
        onClick={() => setSearchQuery("")}
        className="cross-icon-prospect-search"
      >
        {searchQuery && <CloseIcon className="showicons-search" />}
      </div>
      {showSearchdata && (
        <div className="Autocompletedropdown-track">
          {responseData?.length > 0 ? (
            responseData.map((item, index) => (
              <>
                <div
                  className="outterAutocompletedropdown"
                  key={item.id || `data-${index}`}
                >
                  <div
                    onClick={() => handleAddData(item)}
                    className="useralldata"
                  >
                    {item?.name}
                  </div>
                  <div className="separatorline"></div>
                </div>
              </>
            ))
          ) : (
            <div className="useralldata">Not Available</div>
          )}
        </div>
      )}
    </Paper>
  );
};
export default CustomSearchTrackinPaper;
